import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import Config from "./../config.json";

export const imageManagerApi = createApi({
  reducerPath: "imageManagerApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${Config.IPM_SERVER_URL}/api/image/`,
    credentials: "include",
    headers: {
      "X-API-Key": Config.X_API_KEY,
    },
  }),
  endpoints: (builder) => ({
    createImage: builder.mutation({
      query: (image) => ({
        url: "upload-image",
        body: image,
        method: "POST",
      }),
      invalidatesTags: [
        { type: "Image", id: "List" },
        { type: "Image", id: (id) => id },
      ],
    }),

    getImages: builder.query({
      query: (image) => ({
        url: "get-images",
        body: image,
        method: "GET",
      }),
      providesTags: (result) => [
        { type: "Image", id: "List" },
        ...(result ?? []).map((Image) => ({
          type: "Image",
          id: Image.id,
        })),
      ],
    }),

    deleteImage: builder.mutation({
      query: (image) => ({
        url: "delete-image",
        body: image,
        method: "DELETE",
      }),
      invalidatesTags: [
        { type: "Image", id: "List" },
        { type: "Image", id: (id) => id },
      ],
    }),
  }),
});

export const {
  useCreateImageMutation,
  useGetImagesQuery,
  useDeleteImageMutation,
} = imageManagerApi;
